// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_fe8d59a","open":"_eb8dcec","title":"_4faaf75","iconWrapper":"_2e1f9ef","icon":"_f306d9b","iconOpen":"_4d9261d"};